import _toConsumableArray from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import isServer from '../is/isServer';
var storage = new Map();
var localStorageMock = {
  setItem: function setItem(key, value) {
    storage.set(key, value);
  },
  getItem: function getItem(key) {
    return storage.get(key) || null;
  },
  removeItem: function removeItem(key) {
    storage["delete"](key);
  },

  get length() {
    return storage.size;
  },

  key: function key(i) {
    var keys = _toConsumableArray(storage.keys());

    return keys[i] || null;
  },
  clear: function clear() {
    storage.clear();
  }
};
var errorShown = false;

var localStorage = function () {
  if (isServer()) {
    return function () {
      throw new Error('localStorage can not be used on server-side');
    };
  }

  try {
    return window.localStorage ? function () {
      return window.localStorage;
    } : function () {
      return localStorageMock;
    };
  } catch (e) {
    if (!errorShown) {
      console.error('localStorage access error: ', e);
      errorShown = true;
    }

    return function () {
      return localStorageMock;
    };
  }
}();

export default localStorage;